import { render, staticRenderFns } from "./detailsOfStoredValue.vue?vue&type=template&id=07da85f6&scoped=true"
import script from "./detailsOfStoredValue.vue?vue&type=script&lang=js"
export * from "./detailsOfStoredValue.vue?vue&type=script&lang=js"
import style0 from "./detailsOfStoredValue.vue?vue&type=style&index=0&id=07da85f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da85f6",
  null
  
)

export default component.exports